"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./BlockListItems.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _ProductIntroCard = _interopRequireDefault(require("../ProductIntroCard/ProductIntroCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const imageSizes = {
  thumbnail: {
    desktop: {
      width: 275,
      height: 180,
      ratio: {
        width: 55,
        height: 36
      }
    },
    tablet: {
      width: 395,
      height: 254,
      ratio: {
        width: 14,
        height: 9
      }
    },
    mobile: {
      width: 600,
      height: 386,
      ratio: {
        width: 14,
        height: 9
      }
    }
  },
  modal: {
    desktop: {
      width: 1120,
      height: 630,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 840,
      height: 475,
      ratio: {
        width: 168,
        height: 95
      }
    },
    mobile: {
      width: 525,
      height: 296,
      ratio: {
        width: 140,
        height: 79
      }
    }
  }
};
const ProductIntroCards = _ref => {
  let {
    content
  } = _ref;
  const GatsbyImage = content?.GatsbyImage;
  const Link = content?.Link;
  const allCards = content?.cards;
  const nestedInTab = content?.tab;
  const {
    backgroundColor,
    color
  } = content?.theme || {};
  const [colClassName, setColClassName] = (0, _react.useState)("");
  const [firstColumn, setFirstColumn] = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  const [secondColumn, setSecondColumn] = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  const [thirdColumn, setThirdColumn] = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  const [height, setHeight] = (0, _react.useState)(0);
  const getWindowDimensions = () => {
    let width = 0;
    let height = 0;
    if (typeof window !== "undefined") {
      const {
        innerWidth,
        innerHeight
      } = window;
      width = innerWidth;
      height = innerHeight;
    }
    return {
      width,
      height
    };
  };
  const renderProductIntroCards = column => {
    if (column?.length) {
      return column.map((card, index) => {
        const cardContent = {
          logo: card?.logo,
          productName: card?.productName,
          header: card?.header,
          subheader: card?.subheader,
          isSubheaderLong: card?.isSubheaderLong,
          image: card?.image,
          body: card?.body,
          cardLink: card?.cardLink,
          text: card?.cardLink?.text,
          GatsbyImage: GatsbyImage,
          Link: Link,
          viewLessText: card?.viewLessText,
          viewMoreText: card?.viewMoreText,
          cardAlignment: content?.cardAlignment,
          imageSizes: imageSizes?.thumbnail
        };
        if (cardContent?.cardLink) {
          cardContent.cardLink.external = (0, _checkForExternalLink.default)(cardContent?.cardLink?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_ProductIntroCard.default, {
          key: index,
          content: cardContent,
          contentfulId: card?.contentfulId ? card?.contentfulId : null
        });
      });
    }
    return null;
  };
  const setColumns = width => {
    let arraysNeeded = 0;
    let firstCol = [];
    let secondCol = [];
    let thirdCol = [];
    if (width >= 1201) {
      arraysNeeded = 3;
      setColClassName("three-col");
    } else if (width <= 1200 && width >= 801) {
      arraysNeeded = 2;
      setColClassName("two-col");
    } else if (width <= 800) {
      arraysNeeded = 1;
      setColClassName("one-col");
    }
    for (const i in allCards) {
      if (i % arraysNeeded === 0) firstCol.push(allCards[i]);
      if (i % arraysNeeded - 1 === 0) secondCol.push(allCards[i]);
      if (i % arraysNeeded - 2 === 0) thirdCol.push(allCards[i]);
    }
    setFirstColumn(renderProductIntroCards(firstCol));
    setSecondColumn(renderProductIntroCards(secondCol));
    setThirdColumn(renderProductIntroCards(thirdCol));
  };
  (0, _react.useEffect)(() => {
    const {
      width,
      height
    } = getWindowDimensions();
    setHeight(height);
    setColumns(width);
    if (typeof window !== "undefined") {
      const handleResize = () => {
        const {
          width,
          height
        } = getWindowDimensions();
        setHeight(height);
        setColumns(width);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        if (typeof window !== "undefined") {
          window.removeEventListener("resize", handleResize);
        }
      };
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !backgroundColor && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-cards__primitives",
    style: {
      height: colClassName === "two-col" || colClassName === "three-col" ? height : 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-product-intro-cards__primitives__background"
  })), /*#__PURE__*/_react.default.createElement("h3", {
    className: "ter-product-intro-cards__main-heading",
    style: {
      color: color
    }
  }, content?.title), /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-product-intro-cards",
    style: {
      background: nestedInTab ? "#fff" : backgroundColor,
      color: color
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: colClassName
  }, firstColumn), colClassName === "two-col" || colClassName === "three-col" ? /*#__PURE__*/_react.default.createElement("div", {
    className: colClassName
  }, secondColumn) : null, colClassName === "three-col" ? /*#__PURE__*/_react.default.createElement("div", {
    className: colClassName
  }, thirdColumn) : null));
};
var _default = ProductIntroCards;
exports.default = _default;